module.exports = __webpack_public_path__ + "static/img/head_portrait.e08bb202.png";